import { render, staticRenderFns } from "./InputDecimal.vue?vue&type=template&id=516880c7&"
import script from "./InputDecimal.vue?vue&type=script&lang=js&"
export * from "./InputDecimal.vue?vue&type=script&lang=js&"
import style0 from "./InputDecimal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
